module.exports = __webpack_public_path__ + "img/couples-060.182bd014.jpg";